import { CoreIcon } from '../core-icon';
import closeCircleFillSVG from '../../assets/icons/close-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const CloseCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={closeCircleFillSVG} {...props} />;
};
